import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tongue': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM312 408C312 443.6 282.9 472.5 247.1 472 212 471.5 184 442.2 184 407V364.2L201.7 355.4C216.7 347.9 233.2 357.1 236.6 371.9L239.4 384C241.5 393.2 254.6 393.2 256.7 384L259.5 371.9C262.9 357.1 279.3 347.8 294.4 355.4L312.1 364.2V408zM340.2 433.3C342.4 425.2 344 416.8 344 408V364.5C358.2 352.1 368.4 337 371.3 320 373 310.1 363.6 301.5 353.6 304.7 327.7 313 289.2 317.8 248 317.8S168.4 313 142.4 304.7C132.5 301.6 123 310 124.7 320 127.6 337 137.8 352.1 152 364.5V408C152 416.8 153.6 425.2 155.8 433.3 91.8 399.9 48 333 48 256 48 145.7 137.7 56 248 56S448 145.7 448 256C448 333 404.2 399.9 340.2 433.3zM168 176C150.3 176 136 190.3 136 208S150.3 240 168 240 200 225.7 200 208 185.7 176 168 176zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176z'
      }
    ]
  }
})
